import { createGetTextResources } from "../../shared/utils/text-resources-algemeen";
/* istanbul ignore file */

export const getContractTextResources = createGetTextResources({
  opzegdatum: "Opzegdatum mag niet voor begindatum liggen.",
  einddatum: "Einddatum mag niet voor begindatum liggen.",
  einddatumLicentieSoortBetaald: "Einddatum is verplicht voor betaalde licenties."
});
